import { db } from '@/main';
import moment from 'moment'

const state = {
    todo : []
}

// getters
const getters = {

}

// mutations
const mutations = {
    taskActive:(state,payload)=>{
        var updatestatus = "";
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.status == 'ACTIVE'){
                    updatestatus = 'INACTIVE'
                }
                else if(list.status == 'INACTIVE'){
                    updatestatus = 'ACTIVE'
                }
            }
        })

        const updateRef = db.collection('Gift').doc(payload);
        updateRef.update({ status:updatestatus })
    },

    alltaskcomplete:(state,payload)=>{
        var updatestatus = "";
        if(payload) {
            updatestatus = 'complete'    
        } else {
            updatestatus = 'incomplete'
        }
        state.todo.forEach(function (list) {
            const updateRef = db.collection('Gift').doc(list.id);
            updateRef.update({ status:updatestatus })
        })
    },

    tododelete:(state,payload)=>{
        db.collection('Gift').doc(payload).delete()
    },

    addtodo:(state, payload)=>{
        var object = []
        /*
        if (payload.gift_description_english != null)object.push({des_english : payload.gift_description_english})        
        if (payload.gift_description_korean != null)object.push({des_korean : payload.gift_description_korean})
        if (payload.gift_description_spanish != null)object.push({des_spanish : payload.gift_description_spanish})
        if (payload.gift_description_portuguese != null)object.push({des_portuguese : payload.gift_description_portuguese})
        if (payload.gift_description_french != null)object.push({des_french : payload.gift_description_french})
        if (payload.gift_description_german != null)object.push({des_german : payload.gift_description_german})
        if (payload.gift_description_russian != null)object.push({des_russian : payload.gift_description_russian})
        */
       //if (payload.gift_description_english != null)object.push({des_english : payload.gift_description_english})        
       if (payload.gift_message_korean == null)payload.gift_message_korean = ""
       if (payload.gift_message_spanish == null)payload.gift_message_spanish = ""
       if (payload.gift_message_portuguese == null)payload.gift_message_portuguese = ""
       if (payload.gift_message_french == null)payload.gift_message_french = ""
       if (payload.gift_message_german == null)payload.gift_message_german = ""
       if (payload.gift_message_russian == null)payload.gift_message_russian = ""

        object.push({
            english : payload.gift_message_english,
            korean : payload.gift_message_korean,
            spanish : payload.gift_message_spanish,
            portuguese : payload.gift_message_portuguese,
            french : payload.gift_message_french,
            german : payload.gift_message_german,
            russian : payload.gift_message_russian
        })     

        /*
        db.collection('AppGifts').add({
            
            type: payload.gift_type,
            market : payload.gift_market,

            versionCode : parseInt(payload.gift_versionCode),
            deadline : payload.gift_deadline,
            maxAmount : parseInt(payload.gift_maxAmount),

            itemId : payload.gift_itemId,
            itemCount : payload.gift_itemCount,
            
            description : object,            

            status : 'INACTIVE',
            created: new Date()
        })
        */

        db.collection('Gift').add({ 

            type: payload.gift_type,
            market : payload.gift_market,

            versionCode : parseInt(payload.gift_versionCode),
            deadline : payload.gift_deadline,
            giftAvailable : parseInt(payload.gift_available),
            giftGiven : 0,

            item:
            {
                id : parseInt(payload.gift_itemId),
                count : parseInt(payload.gift_itemCount)
            },
            
            status : 'INACTIVE',
            created: new Date(),            

            message: 
            {
                english : payload.gift_message_english,
                korean : payload.gift_message_korean,
                spanish : payload.gift_message_spanish,
                portuguese : payload.gift_message_portuguese,
                french : payload.gift_message_french,
                german : payload.gift_message_german,
                russian : payload.gift_message_russian                
            } 
        })
    },

    retrieveTodos(state,todos){
        state.todo = todos
    }

};

// actions
const actions = {
    retrieveTodos:(context)=>{
        db.collection('Gift').get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                //tempTodos.push(doc.data());
                //tempTodos.push({ id:doc.id, title:doc.data().title, delete:doc.data().delete, status:doc.data().status, created:doc.data().created });
                
                tempTodos.push({ 
                    id:doc.id, 
                    type:doc.data().type, 
                    market:doc.data().market, 
                    versionCode:doc.data().versionCode, 
                    deadline:moment(String(doc.data().deadline.toDate())).format('YYYY-MM-DD hh:mm'),                    
                    giftAvailable:doc.data().giftAvailable, 
                    giftGiven:doc.data().giftGiven, 
                    item:doc.data().item, 
                    message : doc.data().message,
                    /*
                    description_english:doc.data().description_english,
                    description_korean:doc.data().description_korean,
                    description_spanish:doc.data().description_spanish,
                    description_portuguese:doc.data().description_portuguese,
                    description_french:doc.data().description_french,
                    description_german:doc.data().description_german,
                    description_russian:doc.data().description_russian,
                    */
                    status:doc.data().status, 
                    created:moment(String(doc.data().created.toDate())).format('YYYY-MM-DD hh:mm')
                });
                
            })

            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.created.seconds - b.created.seconds
            })

            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    taskActive:(context, payload) => {
        context.commit('taskActive',payload)
    },
    alltaskcomplete:(context,payload) => {
        context.commit('alltaskcomplete',payload)
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    },
    addtodo:(context, payload) => {
        context.commit('addtodo', payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}